// import RemoveCartButton from "./remove_cart_button";
// import AddToCartButton from "./add_cart_button";
import {getCatalogBtn} from "./helper/helpers";
import AnButton from "../../components/an_button";
import {checkBrowser} from "../../utils/helpers";
const removeCartText = gettext("Remove from cart");
const addCartText = gettext("Add to cart");
const addCartUrl = catalogModule.getUrl("add_cart");
const removeCartUrl = catalogModule.getUrl("remove_cart");

export const CartButton = (props) => {
    let product = props.product;
    const productButton = getCatalogBtn();
    const currentBrowser = checkBrowser();
    const [addToCart, setAddToCart] = React.useState(false);
    const [formAttr, setFormAttr] = React.useState({
        text: addCartText,
        btn: `${productButton}`,
        form: `add_from_cart`,
        url: addCartUrl
    });
    React.useEffect(() => {
        if (catalogModule.isInCart(product.key) || addToCart){
            let tempFormAttr = Object.assign({}, formAttr);
            setAddToCart(true);
            tempFormAttr.text = removeCartText;
            tempFormAttr.btn = `${productButton} added`;
            tempFormAttr.form = "remove_from_cart";
            tempFormAttr.url = removeCartUrl
            setFormAttr(tempFormAttr);
        }
    }, [])

    const handleOnSubmit = (e) => {
        let tempFormAttr = Object.assign({}, formAttr);
        let w;
        // Check if product is already in cart
        if(!addToCart){
            // updateNavCart("add");
            if(CartUIRender){
                CartUIRender.updateCartNumState();
            }
            tempFormAttr.text = removeCartText;
            tempFormAttr.btn = `${productButton} added`;
            tempFormAttr.form = "remove_from_cart";
            tempFormAttr.url = removeCartUrl;
            if(typeof formData !== "undefined"){
                catalogModule.addInCart(formData.product);
            }

        } else {
            if(CartUIRender){
                CartUIRender.updateCartNumState('decrease');
            }
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'remove_from_cart',
                'ecommerce': {
                    'remove': {
                        'products': [{
                            'id': product.key,
                        }]
                    }
                }
            });
            tempFormAttr.text = addCartText;
            tempFormAttr.btn = `${productButton}`;
            tempFormAttr.form = "add_from_cart";
            tempFormAttr.url = addCartUrl;
            if(typeof formData !== "undefined"){
                catalogModule.removeInCart(formData.product);
            }
        }
        setAddToCart(!addToCart);
        setTimeout(() => {
            setFormAttr(tempFormAttr);
        }, 1000);
        if(checkBrowser() === "safari"){
            if (!w || w.closed) {
                w = window.open('/cart','cart').focus();
            } else {
                console.log('window is already opened');
            }
            w.focus();
        }
    }

    return (
        <React.Fragment>
            <form onSubmit={handleOnSubmit} target="cart" action={formAttr.url} method="post" className={formAttr.form}>
                <input type="hidden" name='csrfmiddlewaretoken' value={baseBindData.csrfToken} readOnly />
                <input type="hidden" name='key' value={product.key} readOnly />
                <button className={formAttr.btn} type={"submit"}>{formAttr.text}</button>
            </form>
        </React.Fragment>
    )
}

export const CartAnmButton = ({onToggleCart, formAttr, isLoading}) => {
    let loadingState = {
        isLoading: isLoading
    }

    return (
        <React.Fragment>
            <AnButton onHandleClick={onToggleCart}
                      btnAttr={formAttr} loadingAttr={loadingState}/>
        </React.Fragment>
    )
}
